import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicHowOrganizeEvent = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'À propos de Wodzone', link: '/topics/about'},
    { label: 'Premiers pas', link: '/topics/about/first-step'},
    { label: topic.title, link: topic.link},
  ]

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Vous avez peut-être une idée d'event inoubliable. En devenir organisateur vous permet de nouer des liens avec 
              des athltètes de tout horizon. Nous sommes là pour vous aider à vous lancer et à l'exercer tout en prenant plaisir à le faire.
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                Commençons ! Le plus simple et le plus rapide est de<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>contacter</a>directement les équipes de Wodzone.
                Ils seront ravis de pouvoir vous renseigner et de vous guider étapes par étapes. Vous pouvez également jeter un coup d'oeil sur le site
                <a target='_blank' className="link" href="https://wodzone.fr">https://wodzone.fr</a>
              </p>
            </div>
            <div className="article-container mt-56">
              <p className="help-title-part mb-8">{topic.subtitles[1]}</p>
              <p className="help-text">
                Passez de l’autre côté et organisez un événement à votre image !
                Publiez votre événement, que ce soit en ligne ou dans une box/salle de sport, avec des inscriptions limitées ou illimitées. Pour vous accompagner, 
                n’hésitez pas à consulter notre centre d’aide pour<a target='_blank' className="link" href="#">les organisateurs.</a>
              </p>
              <p className="help-text">
                Besoin d'aide ? Découvrez plus d'informations<a target='_blank' className="link" href="#">comment créer votre event.</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicHowOrganizeEvent